import { createSlice } from '@reduxjs/toolkit';
import {
    suelo,
} from '../actions/suelo';


export const SueloReducer = createSlice({
    name: 'suelo',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(suelo.pending, (state) => { state.loading = true })
            .addCase(suelo.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(suelo.rejected, (state) => { state.loading = false })
    }
})

export default SueloReducer.reducer;

